import reject from 'lodash/reject'
import union from 'lodash/union'

export default {
  reject,
  union
}
